import { useTranslations } from 'next-intl';
import {
  HomeCarPark,
  HomeSearchMask,
  HomeTrustSeals,
  HomeUspBadges,
} from '@silvertours/front-features';
import {
  BelowStage,
  GreenStage,
  Headline,
  HeadlineRow,
  SealsBelowSearch,
  SealsOnStage,
  SearchArea,
  StageContent,
  Subline,
  Title,
  UspArea,
} from './HomeFirstViewport.styles';

type HomeFirstViewportProps = {
  headline: string;
};

/**
 * The first viewport of the index page variant.
 * The green stage shows the car park, the headline and the search mask.
 * From xl, the trust seals stand at the right of the headline. Below xl,
 * they follow the search mask. The USP badges close the first viewport.
 */
const HomeFirstViewport = ({ headline }: HomeFirstViewportProps) => {
  const t = useTranslations('features.stage');

  return (
    <div data-first-viewport="variant">
      <GreenStage>
        <HomeCarPark />
        <StageContent>
          <HeadlineRow>
            <Headline>
              <Title>{headline}</Title>
              <Subline>{t('homeFirstViewport.subline')}</Subline>
            </Headline>
            <SealsOnStage>
              <HomeTrustSeals orientation="column" />
            </SealsOnStage>
          </HeadlineRow>
          <SearchArea>
            <HomeSearchMask
              headline={t('homeFirstViewport.searchHeadline')}
              buttonLabel={t('homeFirstViewport.searchButtonLabel')}
            />
          </SearchArea>
        </StageContent>
      </GreenStage>
      <BelowStage>
        <SealsBelowSearch>
          <HomeTrustSeals orientation="row" />
        </SealsBelowSearch>
        <UspArea>
          <HomeUspBadges />
        </UspArea>
      </BelowStage>
    </div>
  );
};

export { HomeFirstViewport };
